import script from "./CompleteRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./CompleteRegistration.vue?vue&type=script&setup=true&lang=js"

import "./CompleteRegistration.vue?vue&type=style&index=0&id=550ed5b7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-550ed5b7"]])

export default __exports__